(function ($) {

    if ($('.page-template-template-calendar').length) {
        var calendarEl = $('#calendar');
        if (window.innerWidth <= 991) {
            var calendar = new FullCalendar.Calendar(calendarEl, {
                height: 400,
                titleFormat: 'MMMM YYYY',
                header: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                columnHeaderFormat: 'dd',
                validRange: {
                    start: '2021-08-01'
                },
                events: calendarEvents
            });
            calendar.render();
        } else {
            var calendar = new FullCalendar.Calendar(calendarEl, {
                height: 500,
                titleFormat: 'MMMM YYYY',
                header: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                columnHeaderFormat: 'dd',
                validRange: {
                    start: '2021-08-01'
                },
                events: calendarEvents
            });
            calendar.render();
        }
        checkActiveDays();
        var date = new Date();
        var nextMonth = moment(date).add(1, 'M');
        if (!$('.day[data-month="' + nextMonth + '"][data-year="' + date.getFullYear() + '"]').length) {
            $('.customNext').addClass('disabled');
        } else {
            $('.customNext').removeClass('disabled');
        }
        $(document).on('mouseenter', '.calendar-list .day', function () {
            var id = $(this).data('id');
            $('#calendar .fc-bgevent.bg-id-' + id).addClass('hovered');
        });

        $(document).on('mouseleave', '.calendar-list .day', function () {
            var id = $(this).data('id');
            $('#calendar .fc-bgevent.bg-id-' + id).removeClass('hovered');
        });

        $(document).on('click', '.selectedDay-wrapper .close-btn, .event-wrapper .close-btn', function () {
            $(this).parent().remove();
            $('#calendar .fc-bgevent').removeClass('clicked');
            $('#calendar td').removeClass('active-click');
            $('.month-wrapper').addClass('active');
            $('.event-wrapper,.selectedDay-wrapper,.news-section, .seasonal').remove();
        });


        $(document).on('click', '.customPrev', function () {
            calendar.prev();
            $('.month-wrapper').addClass('active');
            var date = new Date(calendar.currentDate._i);
            var month = date.getMonth() + 1;
            var nextMonth = month + 1;
            $('.day').addClass('hidden');
            $('.calendar-title').addClass('hidden');
            $('.calendar-title[data-month="' + month + '"]').removeClass('hidden');
            $('.day[data-month="' + month + '"][data-year="' + date.getFullYear() + '"]').removeClass('hidden');
            $('.event-wrapper,.selectedDay-wrapper,.news-section, .seasonal').remove();
            if (date.getMonth() <= 7 && date.getFullYear() <= 2021) {
                $(this).addClass('disabled');
            }
            if ($('.day[data-month="' + nextMonth + '"][data-year="' + date.getFullYear() + '"]').length) {
                $('.customNext').removeClass('disabled');
            }
            checkActiveDays();
        });

        $(document).on('click', '.customNext', function () {
            calendar.next();
            $('.month-wrapper').addClass('active');
            var date = new Date(calendar.currentDate._i);
            var month = date.getMonth() + 1;
            var nextMonth = month + 1;
            $('.day').addClass('hidden');
            $('.calendar-title').addClass('hidden');
            $('.calendar-title[data-month="' + month + '"]').removeClass('hidden');
            $('.day[data-month="' + month + '"][data-year="' + date.getFullYear() + '"]').removeClass('hidden');
            $('.event-wrapper,.selectedDay-wrapper,.news-section, .seasonal').remove();
            if (date.getMonth() >= 8 && date.getFullYear() >= 2021) {
                $('.customPrev').removeClass('disabled');
            }
            if (!$('.day[data-month="' + nextMonth + '"][data-year="' + date.getFullYear() + '"]').length) {
                $('.customNext').addClass('disabled');
            } else {
                $('.customNext').removeClass('disabled');
            }
            checkActiveDays();
        });

        $(document).on('click', '.fc-past, .fc-future, .fc-today', function () {
            $('.fc-past, .fc-future').removeClass('active-click');
            $('#calendar .fc-bgevent').removeClass('clicked');
            $('#calendar .fc-bgevent').removeClass('hovered');
            $(this).addClass('active-click');
            var date = $(this).data('date');
            getCalendarList(date);
            checkActiveDays();
        });

        // $(document).on('click', '.calendar-list .day', function () {
        //     var id = $(this).data('id');
        //     $('#calendar .fc-bgevent').not('.fc-bgevent.bg-id-' + id).removeClass('clicked');
        //     $('#calendar .fc-bgevent').removeClass('hovered');
        //     $('#calendar .fc-bgevent.bg-id-' + id).addClass('clicked');
        //     getEvent(id);
        // });

        function getCalendarList(date) {
            var data = {
                'date': date,
                'action': 'load_calendar_events',
            };
            $('.loading').addClass('active');
            $.get(postmpwp.ajax_url, data, function (response) {
                if (response.success) {
                    $('.event-wrapper, .selectedDay-wrapper').remove();
                    $('.month-wrapper').removeClass('active');
                    $('.calendar-list').append(response.data.calendar);
                    $('.selectedDay-wrapper').find('.calendar-title').text(moment(date).format('MMMM D') + ' d.:');
                    $('.loading').removeClass('active');
                }
            });
        }

        function getEvent(id) {
            var data = {
                'id': id,
                'action': 'load_event',
            };
            $('.loading').addClass('active');
            $.get(postmpwp.ajax_url, data, function (response) {
                if (response.success) {
                    $('.event-wrapper, .selectedDay-wrapper').remove();
                    $('.month-wrapper').removeClass('active');
                    $('.calendar-list').append(response.data.event);
                    $('.calendar-page').append(response.data.newsSection);
                    $('.calendar-page').append(response.data.relatedProducts);
                    var seasonalSwiper = new Swiper('.products-swiper', {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        autoplay: true,
                        navigation: {
                            nextEl: '.swiper-next',
                            prevEl: '.swiper-prev',
                        },
                        breakpoints: {
                            450: {
                                slidesPerView: 2
                            },
                            750: {
                                slidesPerView: 3
                            },
                            1050: {
                                slidesPerView: 4
                            }
                        }
                    })
                    $('.loading').removeClass('active');
                }
            });
        }

        function checkActiveDays() {
            if ($('.day.hidden').length != $('.day').length) {
                $('.not-found').addClass('hidden');
            } else {
                $('.not-found').removeClass('hidden');
            }
        }
    }

})(jQuery);